import { PictureModel } from "../../pictures/models/PictureModel";
import { WebsiteModel } from "../../websites/models/WebsiteModel";

export interface EditProductModel {
    id: number;
    name: string;
    description: string;
    link: string;
    weight: number;
    dimension: string;
    note: string;
}

export interface ProductModel extends EditProductModel {
    website?: WebsiteModel;
    picture?: PictureModel;
}

export const createProduct = (): ProductModel => ({
    id: 0,
    name: "",
    description: "",
    link: "",
    weight: 0,
    dimension: "",
    note: ""
});